// extracted by mini-css-extract-plugin
export default {"verticalNav":"index_verticalNav_-Pc18"};